<template>
    <SfSection
        v-if="block && block.downloads && block.downloads.length"
        class="downloads"
    >
        <template
            v-if="block.title"
            v-slot:title
        >
            {{ block.title }}
        </template>

        <template v-slot:default>
            <sf-content-container>
                <ul class="downloads__list">
                    <li
                        v-for="(download, index) in block.downloads"
                        :key="`download-${index}`"
                    >
                        <sf-icon icon="document" />
                        <a
                            :href="getDownloadUrl(download)"
                            target="_blank"
                        >
                            {{ download.label }}
                        </a>
                    </li>
                </ul>
            </sf-content-container>
        </template>
    </SfSection>
</template>

<script>
import contentBlockMixin from '~/mixins/content-block';
import SfIcon from '~/patterns/atoms/icon/icon.vue';
import SfSection from '~/patterns/organisms/section/section';
import SfContentContainer from '~/patterns/organisms/content-container/content-container';

export default {
    components: {
        SfSection,
        SfContentContainer,
        SfIcon
    },

    mixins: [
        contentBlockMixin
    ],

    props: {
        link: {
            type: Object,
            default: null
        }
    },

    methods: {
        getDownloadUrl(download) {
            // Data from graphql comes wrapped in an array,
            if (download.download.length) {
                return download.download[0].url;
            }

            // Data from algolia comes as an object.
            return download.download.url;
        }
    }
};
</script>

<style lang="less">
.downloads {
    .sf-page-container {
        // Reset margins from section
        margin: 0;
        margin-left: 0;
    }
}

.downloads__list {
    .list-clean();
    font-family: var(--font-family-secondary);
    font-size: var(--font-size-lg);

    a {
        text-decoration: none;
    }

    li:not(:last-of-type) {
        margin-bottom: 1.3125rem;
    }

    .dn-icon {
        vertical-align: middle;
        margin-right: .75rem;
    }

    .dn-icon svg {
        width: 1.125rem;
        height: 1.375rem;
    }
}
</style>
